export default "__VITE_ASSET__BuGv4nlj__"